import {
  RESET_USER_CHOICES,
  RESET_ADDRESS,
  RESET_DASHBOARD,
  RESET_FINANCIAL,
  RESET_CASE_CREATION
} from "../../ducks/redux/actionTypes";
import { releaseAssetArrayDispatch, saveIsHHSRSEnabledP360Toggle, storeAPIErrors, storeSORDAMP } from "../../ducks/redux/actions/FinancialReferral";


import {
  userChosenSearchText,
  userChosenSearchType,
  userChosenBackButton,
  loginStatus,
  userChoicesPermissions,
  isRepairMediAllowed,
  searchTextCountValue,
  appConfigVandalismToggle,
  isRepairCovidAllowed,
  demobilizedContractorSites,
  isCaseAllowed,
  checkEnhancedRepairEligibilityP360,
  saveEdEnabled,
  saveDMQuestionnaireEnabled,
  saveDMReportPreferenceEnabled,
  saveHHRSReportPreferenceEnabled,
  saveDMReportingComplianceEffectiveDate,
  saveAdditionalDMWorkOrderRequired,
  saveWOCreationTimeoutSeconds,
  saveWOCreationPollingDelaySeconds,
  saveAvailabilityWaitTimeSeconds,
  saveRecallEligibilityPeriodInMonths,
  saveWOCancellationTimeoutSeconds,
  saveWOCancellationPollingDelaySeconds,
  skipResponsibilityCheckForEMA,
  saveIsHHSRSRepairEnabled,
} from "../../ducks/redux/actions/userChoices";

export const resetReduxState = (dispatch: any, stateNotToBeReset: any) => {
  dispatch({ type: RESET_USER_CHOICES });
  dispatch({ type: RESET_ADDRESS });
  dispatch({ type: RESET_DASHBOARD });
  dispatch({ type: RESET_FINANCIAL });
  dispatch({ type: RESET_CASE_CREATION });

  dispatch(userChosenSearchText(stateNotToBeReset.SearchText));
  dispatch(userChosenSearchType(stateNotToBeReset.SearchType));
  dispatch(userChosenBackButton(stateNotToBeReset.BackButton));
  dispatch(userChoicesPermissions(stateNotToBeReset.Permissions));
  dispatch(loginStatus(stateNotToBeReset.LoginStatus));
  dispatch(saveIsHHSRSRepairEnabled(stateNotToBeReset.isHHSRSRepairEnabled)); 
  dispatch(isRepairMediAllowed(stateNotToBeReset.isRepairMediaAllowed));
  dispatch(searchTextCountValue(stateNotToBeReset.searchTextCountValue));
  dispatch(appConfigVandalismToggle(stateNotToBeReset.vandalismtoggleValue));
  dispatch(isRepairCovidAllowed(stateNotToBeReset.isRepairCovidAllowed));
  dispatch(demobilizedContractorSites(stateNotToBeReset.demobilizedContractorSites));
  dispatch(isCaseAllowed(stateNotToBeReset.isCaseAllowed));
  dispatch(checkEnhancedRepairEligibilityP360(stateNotToBeReset.checkEnhancedRepairEligibilityP360));
  dispatch(saveEdEnabled(stateNotToBeReset.isEDEnabled));
  dispatch({ type: "ED_CONFIG_OVERRIDE_URL", payload: stateNotToBeReset.edConfigOverrideUrl });
  dispatch({ type: "ED_CONFIG_CUSTOMER", payload: stateNotToBeReset.edConfigCustomer });
  dispatch({ type: "ED_CONFIG_ACTIVE_HOUSING_SCRIPT_URL", payload: stateNotToBeReset.edConfigActiveHousingScriptUrl });
  dispatch(saveDMQuestionnaireEnabled(stateNotToBeReset.isDMQuestionnaireEnabled));
  dispatch(saveDMReportPreferenceEnabled(stateNotToBeReset.isDMReportPreferenceEnabled));
  dispatch(saveHHRSReportPreferenceEnabled(stateNotToBeReset.isHHRSReportPreferenceEnabled));
  dispatch(saveDMReportingComplianceEffectiveDate(stateNotToBeReset.DMReportingComplianceEffectiveDate));
  dispatch(saveAdditionalDMWorkOrderRequired(stateNotToBeReset.isAdditionalDMWorkOrderRequired));
  dispatch(saveWOCreationTimeoutSeconds(stateNotToBeReset.woCreationTimeoutSeconds));
  dispatch(saveWOCreationPollingDelaySeconds(stateNotToBeReset.woCreationPollingDelaySeconds));
  dispatch({ type: "IS_CASEMANAGEMENT_TOGGLE", payload: stateNotToBeReset.isCaseManagementToggle });
  dispatch({ type: "IS_UPDATEANACTION_TOGGLE", payload: stateNotToBeReset.isUpdateAnActionToggle });
  dispatch(releaseAssetArrayDispatch(null));
  dispatch({ type: "TENANCY_TYPE_DESCRIPTION", payload: "" });
  dispatch(storeAPIErrors([]));
  dispatch(saveAvailabilityWaitTimeSeconds(stateNotToBeReset.availabilityWaitTimeSeconds));
  dispatch(saveRecallEligibilityPeriodInMonths(stateNotToBeReset.recallEligibilityPeriodInMonths));
  dispatch(storeSORDAMP(stateNotToBeReset.storeSORDAMP));
  dispatch(saveWOCancellationTimeoutSeconds(stateNotToBeReset.woCancellationTimeoutSeconds));
  dispatch(saveWOCancellationPollingDelaySeconds(stateNotToBeReset.woCancellationPollingDelaySeconds));
  dispatch(skipResponsibilityCheckForEMA(stateNotToBeReset.skipResponsibilityCheckForEMA));
  dispatch(saveIsHHSRSEnabledP360Toggle(stateNotToBeReset.isHHSRSEnabled));
};